<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="tranDialog"
      persistent
      max-width="74%"
    >
      <v-card>
        <v-card-title style="padding-bottom: 0px">
          <v-flex
            xs11
            sm11
            md11
          ><span class="headline">{{ customerName }} Transactions</span></v-flex>
          <v-flex
            xs1
            sm1
            md1
          >
            <v-btn
              flat
              @click="closeDialog()"
              class="close"
            ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
          </v-flex>
        </v-card-title>
        <v-card-text id="print-area-invoices">
          <table
            cellspacing="0"
            id="head-table"
          >
            <tr>
              <td style="padding-left: 20px">
                <img
                  style="width: 110px; height: 100px"
                  src="../../../assets/images/black_shipzone.png"
                  alt=""
                />
              </td>
              <td>
                <table
                  cellspacing="0"
                  id="company-info"
                  style="width: 100%; margin-left: 0px"
                >
                  <tr class="header-table">
                    <td style="font-size: 14px; padding-right: 20px">
                      {{ companyData.company_name }}
                    </td>
                  </tr>
                  <tr class="header-table">
                    <td style="font-size: 14px; padding-right: 20px">
                      {{ companyData.company_address }}
                    </td>
                  </tr>
                  <tr class="header-table">
                    <td style="font-size: 14px; padding-right: 20px">
                      {{ companyData.company_email }}
                    </td>
                  </tr>
                  <tr class="header-table">
                    <td style="font-size: 14px; padding-right: 20px">
                      {{ companyData.phone_number }}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>

          <v-layout
            row
            wrap
            style="margin-bottom: 20px"
            class="not-printable"
          >
            <v-flex
              xs4
              sm3
              md2
              lg2
              style="margin-left: 5px"
            >
              <date-picker
                style="border-bottom-color: #919191"
                :date="fromDate"
                :option="option"
                class="form-control"
              ></date-picker>
            </v-flex>

            <v-flex
              xs4
              sm3
              md2
              lg2
              style="margin-left: 20px"
            >
              <date-picker
                style="border-bottom-color: #919191"
                :date="toDate"
                :option="option1"
                class="form-control"
              ></date-picker>
            </v-flex>

            <v-flex
              xs4
              sm6
              md2
              style="margin-left: 20px"
            >
              <v-btn
                @click="filterByDate()"
                style="height: auto"
                depressed
              >
                Filter
              </v-btn>
            </v-flex>

            <v-flex
              xs4
              sm4
              md2
              style="margin-left: 20px"
            >
              <v-btn
                @click="removeDateFilter()"
                style="height: auto"
                depressed
              >
                Remove Filter
              </v-btn>
            </v-flex>

            <v-flex
              xs4
              sm4
              md2
              style="margin-left: 20px"
            >
              <v-btn
                @click="sendToExport()"
                style="height: auto"
                depressed
                color="primary"
              >
                Export
              </v-btn>
            </v-flex>
          </v-layout>

          <table
            style="width: 100%; margin-top: 15px; margin-bottom: 15px"
            cellspacing="0"
          >
            <tr>
              <td class="fm-roboto fs-14">Customer: {{ customerName }}</td>
              <td
                class="fm-roboto fs-14"
                v-if="form.from_date"
              >From date: {{ form.from_date }}</td>
              <td
                class="fm-roboto fs-14"
                v-if="form.to_date"
              >To date: {{ form.to_date }}</td>
            </tr>
          </table>

          <v-layout
            row
            wrap
            class="not-printable px-2"
          >
            <v-flex
              xs12
              sm4
              md4
              lg4
            >
              <v-text-field
                append-icon="search"
                label="Search"
                v-model="search"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <table
            style="width: 100%"
            cellspacing="0"
          >
            <thead>
              <tr>
                <th class="text-align-left fs-14 bottom-border fm-roboto py-4px px-6px">Date</th>
                <!-- <th class="text-align-left fs-14 bottom-border fm-roboto py-4px px-6px">Branch</th> -->
                <th class="text-align-left fs-14 bottom-border fm-roboto py-4px px-6px">Description</th>
                <th class="text-align-left fs-14 bottom-border fm-roboto py-4px px-6px">Invoice No</th>
                <th class="text-align-left fs-14 bottom-border fm-roboto py-4px px-6px">Product Name</th>
                <th class="text-align-left fs-14 bottom-border fm-roboto py-4px px-6px">Quantity</th>
                <th class="text-align-left fs-14 bottom-border fm-roboto py-4px px-6px">Credit</th>
                <th class="text-align-left fs-14 bottom-border fm-roboto py-4px px-6px">Debit</th>
                <th class="text-align-left fs-14 bottom-border fm-roboto py-4px px-6px">Balance</th>
                <th class="text-align-left fs-14 bottom-border fm-roboto py-4px px-6px">Note</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, index) in filteredData"
                :key="index"
                class="on-hover"
              >
                <template v-if="index == 0">
                  <td
                    colspan="7"
                    class="text-align-center fs-14 bottom-border fm-roboto py-4px px-6px"
                  >Opening Balance</td>
                  <td class="text-align-left fs-14 bottom-border fm-roboto py-4px px-6px">{{ row.balance | usdFormat }}</td>
                  <td class="text-align-left fs-14 bottom-border fm-roboto py-4px px-6px"></td>
                </template>

                <template v-else>
                  <td class="text-align-left fs-14 bottom-border fm-roboto py-4px px-6px">{{ row.created_at | moment('YYYY-MM-DD') }}</td>
                  <!-- <td class="text-align-left fs-14 bottom-border fm-roboto py-4px px-6px">{{ row.branch_name }}</td> -->
                  <td class="text-align-left fs-14 bottom-border fm-roboto py-4px px-6px">{{ row.description }}</td>
                  <td class="text-align-left fs-14 bottom-border fm-roboto py-4px px-6px">{{ row.invoice_number }}</td>
                  <td
                    style="max-width: 250px"
                    class="text-align-left fs-14 bottom-border fm-roboto py-4px px-6px"
                  >{{ row.type == 'order' ? row.product_name : '' }}</td>
                  <td class="text-align-left fs-14 bottom-border fm-roboto py-4px px-6px">{{ row.type == 'order' ? row.quantity : '' }}</td>
                  <td class="text-align-left fs-14 bottom-border fm-roboto py-4px px-6px">{{ row.credit | usdFormat }}</td>
                  <td class="text-align-left fs-14 bottom-border fm-roboto py-4px px-6px">{{ row.debit | usdFormat }}</td>
                  <td class="text-align-left fs-14 bottom-border fm-roboto py-4px px-6px">{{ row.balance | usdFormat }}</td>
                  <td class="text-align-left fs-14 bottom-border fm-roboto py-4px px-6px">{{ row.note }}</td>
                </template>
              </tr>
              <tr
                v-if="tranData.totals"
                style="background-color: #ddd; font-weight: bold"
              >
                <td colspan="5"></td>
                <td class="fm-roboto fs-14 py-4px px-6px">{{ tranData.totals.credit | usdFormat }}</td>
                <td class="fm-roboto fs-14 py-4px px-6px">{{ tranData.totals.debit | usdFormat }}</td>
                <td class="fm-roboto fs-14 py-4px px-6px">{{ tranData.totals.balance | usdFormat }}</td>
                <td class="fm-roboto fs-14 py-4px px-6px"></td>
              </tr>
            </tbody>
          </table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            style="height: auto"
            @click="closeDialog()"
            outline
            color="normal"
          >Close</v-btn>

          <v-btn
            style="height: auto"
            @click="print()"
            outline
            color="primary"
          >Print</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from 'axios'
import myDatepicker from 'vue-datepicker'
import swal from 'sweetalert'

export default {
  props: ['tranDialog', 'customerName', 'customerId'],

  components: {
    'date-picker': myDatepicker
  },

  data() {
    return {
      tranData: {
        data: []
      },
      form: {},
      companyData: {},
      fromDate: {},
      toDate: {},
      search: null,
      option: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD',
        placeholder: 'From Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d',
          width: '100%'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      option1: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD',
        placeholder: 'To Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d',
          width: '100%'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      }
    }
  },

  computed: {
    filteredData() {
      if (this.search) {
        return this.tranData.data.filter(data => {
          if (data.description) {
            if (data.type === 'order') {
              return data.description.toLowerCase().includes(this.search.toLowerCase()) ||
                data.product_name.toLowerCase().includes(this.search.toLowerCase())
              // data.branch_name.toLowerCase().includes(this.search.toLowerCase())
            }
            return data.description.toLowerCase().includes(this.search.toLowerCase())
            // data.branch_name.toLowerCase().includes(this.search.toLowerCase())
          }
        })
      }

      return this.tranData.data
    },

    totals() {
      let credit = 0
      let debit = 0
      this.filteredData.forEach(x => {
        credit += Number(x.credit)
        debit += Number(x.debit)
      })

      return {
        credit: credit.toLocaleString(),
        debit: debit.toLocaleString(),
        balance: (credit - debit).toLocaleString()
      }
    }
  },

  watch: {
    tranDialog: {
      immediate: false,
      handler() {
        if (this.tranDialog) {
          this.getTranData()
          this.getCompanyData()
        }
      }
    }
  },

  methods: {
    closeDialog() {
      this.form = {}
      this.fromDate = {}
      this.toDate = {}
      this.tranData = {}
      this.$emit('close-dialog')
    },

    getCompanyData() {
      let token = localStorage.getItem('access_token')

      axios
        .get('api/company_info', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.companyData = response.data.data
        })
    },

    print() {
      const notPrintable = document.querySelectorAll('.not-printable')
      notPrintable.forEach(e => {
        e.style.display = 'none'
      })

      const fs14 = document.querySelectorAll('.fs-14')
      fs14.forEach(e => {
        e.style.fontSize = '10px'
      })

      this.$htmlToPaper('print-area-invoices')

      notPrintable.forEach(e => {
        e.style.display = 'flex'
      })

      fs14.forEach(e => {
        e.style.fontSize = '14px'
      })
    },

    getTranData() {
      let token = localStorage.getItem('access_token')
      axios
        .post(`api/customer_transaction/${this.customerId}`, this.form, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.tranData = response.data
        })
    },

    filterByDate() {
      this.form = {}
      if (this.fromDate.time && this.toDate.time) {
        this.form = {
          from_date: this.fromDate.time,
          to_date: this.toDate.time
        }
        this.getTranData()
      } else {
        swal('', 'Please select both date!', 'warning')
      }
    },

    removeDateFilter() {
      this.form = {}
      this.fromDate = {}
      this.toDate = {}
      this.getTranData()
    },

    sendToExport() {
      let hostName = window.location.hostname
      let protocol = window.location.protocol + '//'
      let fullHostName = protocol + hostName
      let params = new URLSearchParams()

      if (this.form.from_date) {
        params.append('from_date', this.form.from_date)
      }
      if (this.form.to_date) {
        params.append('to_date', this.form.to_date)
      }
      if (this.search) {
        params.append('search', this.search)
      }

      let query = params.toString()
      window.location.replace(
        fullHostName + '/api/customer_transaction/' + this.customerId + '/export' + (query ? '?' + query : '')
      )
    }
  }
}
</script>

<style scoped>
.on-hover:hover {
  background-color: #eee;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/user/customerTransactions.vue